var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhiteProject(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_135",
    "data-name": "Group 135",
    transform: "translate(0 0.495)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_126",
    "data-name": "Rectangle 126",
    width: 20,
    height: 20,
    transform: "translate(0 -0.495)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_110",
    "data-name": "Group 110",
    transform: "translate(1.746 1.205)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_232",
    "data-name": "Path 232",
    d: "M1709.128,1395.051h-2.494v-4.336h-3.308v4.336h-6.312a.474.474,0,0,0,0,.949h12.113a.474.474,0,1,0,0-.949Z",
    transform: "translate(-1696.54 -1379.635)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_233",
    "data-name": "Path 233",
    d: "M1769.2,1413.56h-.64a.475.475,0,0,0,0,.949h.64a.475.475,0,0,0,0-.949Z",
    transform: "translate(-1754.505 -1398.144)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_234",
    "data-name": "Path 234",
    d: "M1779.885,1413.56h-.251a.475.475,0,1,0,0,.949h.251a.475.475,0,0,0,0-.949Z",
    transform: "translate(-1763.479 -1398.144)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_235",
    "data-name": "Path 235",
    d: "M1701.413,1342.173h13.331a1.049,1.049,0,0,0,1.049-1.049v-7.742a1.049,1.049,0,0,0-1.049-1.049h-13.331a1.049,1.049,0,0,0-1.049,1.049v7.742A1.049,1.049,0,0,0,1701.413,1342.173Zm2.384-1.121h-1.139v-2h1.139Zm2.063,0h-1.139v-1.12h1.139Zm5.853,0h-1.139v-2h1.139Zm2.2,0h-1.139v-3.414h1.139Zm-10.5-6.1a1.524,1.524,0,0,1,1.441,2.034l1.9.869a1.521,1.521,0,0,1,2.085-.173l2.446-1.791a1.537,1.537,0,1,1,.7.667l-2.62,1.918a1.528,1.528,0,1,1-3,.4c0-.052,0-.1.008-.155l-2.116-.966a1.528,1.528,0,1,1-.841-2.8Z",
    transform: "translate(-1699.638 -1332.334)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteProject);
export default __webpack_public_path__ + "static/media/white_project.c85f5d162ed7775d40b19afd51bce2d0.svg";
export { ForwardRef as ReactComponent };